var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7985 8.74785C12.6864 5.85785 8.72683 5.70202 9.68308 1.5016C9.75391 1.18994 9.421 0.949103 9.15183 1.11202C6.58058 2.62785 4.73183 5.6666 6.28308 9.64744C6.41058 9.97327 6.02808 10.2779 5.75183 10.0654C4.46975 9.09494 4.33516 7.69952 4.4485 6.70077C4.491 6.33244 4.00933 6.15535 3.80391 6.45994C3.32225 7.1966 2.8335 8.3866 2.8335 10.1787C3.10266 14.1454 6.45308 15.3637 7.65725 15.5195C9.3785 15.7391 11.2414 15.4204 12.5802 14.1949C14.0535 12.8279 14.5918 10.6462 13.7985 8.74785ZM7.22516 12.3108C8.24516 12.0629 8.76933 11.3262 8.911 10.6745C9.14475 9.6616 8.231 8.66994 8.84725 7.0691C9.081 8.39369 11.1635 9.22244 11.1635 10.6674C11.2202 12.4595 9.27933 13.9966 7.22516 12.3108Z",
    fill: "#EC1F51"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.d6012961627e99f53478f362867abd5c.svg";
export { ForwardRef as ReactComponent };